import CatalogueModule from './catalogue.module';
import ProjectTokenModule from './project-token.module';

function initialState() {
    return {}
}

export default {
    namespaced: true,
    state:      initialState,
    getters:    {},
    actions:    {
        async init({dispatch}) {
            dispatch('projects/project/extension/catalogue/loadCatalogues', {}, { root: true });
            dispatch('projects/extension/catalogue/projectToken/loadProjectTokens', {}, { root: true });
        }
    },
    mutations:  {},
    modules:    {
        catalogue:    CatalogueModule,
        projectToken: ProjectTokenModule,
    }
}
